import React from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from 'dayjs';

const baseStyle = {
  caption: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
};

const Fields = ({ data, type, jvmBackgroundColor }) => {
  return (
    <div className="flex flex-wrap mt-5 gap-x-10 gap-y-3">
      {type === 'RESOURCECOLUMN' && (
        <div>
          <Typography>{data.articleNumber}</Typography>
        </div>
      )}
      <div>
        <Typography>{data.operationName}</Typography>
        <Typography>{data.productionoperationComment}</Typography>
      </div>
      <div>
        <Typography variant="caption" sx={{ ...baseStyle.caption }}>
          Vevőhivatkozási szám
        </Typography>
        <Typography>{data?.reference}</Typography>
      </div>
      {type === 'RESOURCECOLUMN' ? (
        <Accordion sx={{ width: '100%', background: 'none' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography component="span">További információk</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Gyártandó mennyiség
              </Typography>
              <Typography>{`${data.productionQuantity} ${data.articleQtyCode}`}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Vevő
              </Typography>
              <Typography>{data.companyname}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Kezdés
              </Typography>
              <Typography>{dayjs(data.startDate).format('YYYY-MM-DD')}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Megjegyzés
              </Typography>
              <Typography>{data.productionoperationComment}</Typography>
            </div>
            <div>
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Előző művelet státusz
              </Typography>
              <div>
                {data?.prevStatusLabel && (
                  <Chip
                    label={data?.prevStatusLabel}
                    size="small"
                    sx={{ backgroundColor: jvmBackgroundColor?.jobMonitorChipColor }}
                  />
                )}
              </div>
            </div>
            <div>
              <div className="mb-2">
                <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                  Befejezés
                </Typography>
                <Typography>{dayjs(data.BefejezesiHatarido).format('YYYY-MM-DD')}</Typography>
              </div>
            </div>
            {data.weight && (
              <div>
                <div className="mb-2">
                  <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                    Cikk súlya
                  </Typography>
                  <Typography>{data.weight} kg</Typography>
                </div>
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      ) : (
        <>
          <div>
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Gyártandó mennyiség
            </Typography>
            <Typography>{`${data.productionQuantity} ${data.articleQtyCode}`}</Typography>
          </div>
          <div>
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Vevő
            </Typography>
            <Typography>{data.companyname}</Typography>
          </div>
          <div>
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Kezdés
            </Typography>
            <Typography>{dayjs(data.startDate).format('YYYY-MM-DD')}</Typography>
          </div>
          <div className="mb-2">
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Befejezés
            </Typography>
            <Typography>{dayjs(data.BefejezesiHatarido).format('YYYY-MM-DD')}</Typography>
          </div>
          {data.weight && (
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Cikk súlya
              </Typography>
              <Typography>{data.weight} kg</Typography>
            </div>
          )}
          <div className="flex gap-1 items-center">
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Előző művelet státusz:
            </Typography>
            <div>
              {data?.prevStatusLabel && (
                <Chip
                  label={data?.prevStatusLabel}
                  size="small"
                  sx={{ backgroundColor: jvmBackgroundColor?.jobMonitorChipColor }}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Fields;
